import React, { Component, } from "react"
import {
   FaFileImage,
   FaImage,
} from 'react-icons/fa';
import '../../css/Settings.css'
import { MdOutlineCrop } from 'react-icons/md';
import { Avatar, Grid } from "@mui/material";
import { styled } from '@mui/material/styles';
import Modal from "@mui/material/Modal";
import Fade from 'react-reveal/Fade';
import Badge from "@mui/material/Badge";
import IconButton from "@mui/material/IconButton";
import Button from "@mui/material/Button";
import CloseIcon from '@mui/icons-material/Close';
import Typography from "@mui/material/Typography";
import { Slider } from '@mui/material'
import Cropper from 'react-easy-crop';
import create_image_edit from "../common/common/create_image_edit";
import get_and_post_data_skeleton from '../common/common/get_and_post_data_skeleton';
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { IoClose } from "react-icons/io5";
import { withRouter } from "../common/common/withRouter";

const CustomSlider = styled(Slider)(({ theme }) => ({
   color: 'var(--brand-color)', //color of the slider between thumbs
   "& .MuiSlider-rail": {
      color: 'var(--brand-color)' ////color of the slider outside  teh area between thumbs
   }
}));

const paths = require('../../paths.json');

const LightTooltip = styled(({ className, ...props }) => (
   <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
   [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: '#222222 !important',
      color: '#ffffff',
      boxShadow: theme.shadows[1],
      fontSize: 11,
      margin: '0px'
   },
}));

const style = {
   outline: 0,
   border: 'none',
   top: '50%',
   left: '50%',
   transform: 'translate(-50%, -50%)',
   width: 400,
   boxShadow: 24,
   p: 4,
};


class AvatarEditorCreatorView extends Component {
   constructor(props) {
      super(props);
      this.state = {
         imageFile: '',
         imageBase64: '',
         user_id: undefined,
         newPath: '',
         currentImage: false,
         editIconImageOn: false,
         invalidIconFile: false,
         zoomCropIconImage: false,
         zoomCropHeaderImage: false,
         zoomCropInfo: { x: 0, y: 0, width: 0, height: 0 },
         crop: { x: 0, y: 0 },
         zoom: 1,
         isIconConfirmed: false,
         bottomMobilePadding: window.innerWidth < 600 ? '20px 0 100px 0' : '20px 0 0 0',
         cropperHeight: window.innerWidth < 600 ? '350px' : 'unset'
      };
      this.EditCropZoomIconImageOn = this.EditCropZoomIconImageOn.bind(this)
      this.get_and_post_data_skeleton = this.get_and_post_data_skeleton.bind(this);
      this.create_image_edit = this.create_image_edit.bind(this);
      this.handleBottomMobilePadding = this.handleBottomMobilePadding.bind(this);
   }

   get_and_post_data_skeleton = get_and_post_data_skeleton

   componentDidMount() {
      // console.log(this.props.url)
      if (this.props.url) {
         this.getFileFromUrl(`${paths.BACKEND_URL}api/user/icon`);
         // console.log('getting file from url')
      }
      window.addEventListener('resize', this.handleBottomMobilePadding);
   }

   componentWillUnmount() {
      window.removeEventListener('resize', this.handleBottomMobilePadding);
   }


   resetToOriginal() {
      this.setState({ imageFile: '', imageBase64: '' });
      this.getFileFromUrl(`${paths.BACKEND_URL}api/user/icon`);
   }




   componentDidUpdate(prevProps, prevState) {
      // console.log(this.state.imageFile);
      // console.log(this.state.imageBase64);

      // Check if the URL has changed
      if (prevProps.url !== this.props.url) {
         // console.log('url changed')
         this.setState({ imageFile: '', imageBase64: '' });
         this.getFileFromUrl(`${paths.BACKEND_URL}api/user/icon`);
      }

      // Check if the image file has changed
      if (prevState.imageFile !== this.state.imageFile && this.state.imageFile) {
         // console.log('image file changed')
         this.imageToBase64(this.state.imageFile);
      }

      // Check if the base64 image has changed and call the provided callback
      if (this.props.onImageBase64 && prevState.imageBase64 !== this.state.imageBase64) {
         this.props.onImageBase64(this.state.imageBase64);
      }

      // Clears preview image to blank if user has not uploaded a new image && this.props.url === 'http://localhost:4566/fitwith/'
      if (prevProps.influencerIconUpdated !== this.props.influencerIconUpdated) {
         // Reset the imageFile state and fetch the new file
         this.setState({ imageFile: '', imageBase64: '' }, () => {
            this.getFileFromUrl(`${paths.BACKEND_URL}api/user/icon`);
         });
      }


      // Handle reverting the image
      if (this.props.revertImage === true) {
         // console.log('reverting image')
         this.setState({ imageFile: '', imageBase64: '' });
         this.getFileFromUrl(`${paths.BACKEND_URL}api/user/icon`);
         this.props.setRevertImageFalse();
      } else {
         // console.log('not reverting image')
      }
   }


   async getFileFromUrl(url) {
      // console.log(url)
      // const r = await fetch(url, {
      //    method: 'get',
      //    // credentials: 'include',
      //    redirect: 'follow',
      //    referrerPolicy: 'origin',
      //    mode: 'cors'
      // })
      // const file = await r.blob();
      // const request = await new Promise((resolve, reject) => {
      //    const xhr = new XMLHttpRequest()
      //    xhr.open('get', url)
      //    xhr.responseType = 'arraybuffer'
      //    xhr.addEventListener('load', () => resolve(xhr))
      //    xhr.addEventListener('error', (error) => reject(error))
      //    xhr.send()
      // })
      // this.setState({imageFile: new Blob([request.response], {type: request.getResponseHeader('Content-Type')})})
      const resizedImage = await new Promise((resolve, reject) => {
         const image = new Image();
         image.setAttribute('crossOrigin', 'use-credentials');
         image.onload = (imageEvent) => {
            // Resize the image
            const canvas = document.createElement('canvas');
            let width = image.width;
            let height = image.height;
            canvas.width = width;
            canvas.height = height;
            canvas.getContext('2d').drawImage(image, 0, 0, width, height);
            canvas.toBlob(resolve, 'image/jpeg');
         }
         image.src = url + '?' + escape(new Date());
      })
      this.setState({ imageFile: resizedImage })
      return resizedImage
   }

   handleBottomMobilePadding() {
      window.innerWidth < 600 ? this.setState({ bottomMobilePadding: '20px 0 100px 0' }) :
         this.setState({ bottomMobilePadding: '20px 0 0 0' })
      window.innerWidth < 600 ? this.setState({ cropperHeight: '350px' }) :
         this.setState({ cropperHeight: 'unset' })
   }

   async imageToBase64(file) {
      return new Promise((resolve, reject) => {
         const reader = new FileReader();
         if (
            (
               String(file.type).endsWith('jpg')
            ) || (
               String(file.type).endsWith('jpeg')
            ) || (
               String(file.type).endsWith('png')
            )
         ) {
            reader.onload = (e) => resolve(e);
            reader.onerror = (e) => reject(e);
            this.setState({ invalidIconFile: false });
         } else {
            this.setState({ invalidIconFile: true });
         }
         reader.readAsDataURL(file); // convert to base64 string
      }).then((e) => {
         this.setState({ imageBase64: e.target.result })
      })
   }

   EditIconImageOn() {
      this.setState({ editIconImageOn: true })
   }

   EditIconImageOff() {
      this.setState({ editIconImageOn: true })
   }

   EditCropZoomIconImageOn(event) {
      this.setState({ zoomCropIconImage: true })
      this.setState({ zoom: 1 })
      this.setState({ crop: { x: 0, y: 0 } })
      this.setState({ zoom_crop_info: { x: 0, y: 0, width: 0, height: 0 } })
   }

   async EditCropZoomIconImageOff(event) {
      try {
         const image = await new Promise((resolve, reject) => {
            const image = new Image()
            image.addEventListener('load', () => resolve(image))
            image.addEventListener('error', (error) => reject(error))
            image.setAttribute('crossOrigin', 'anonymous') // needed to avoid cross-origin issues on CodeSandbox
            image.src = this.state.imageBase64
         })
         var canvas = document.createElement('canvas');
         canvas.width = 512;
         canvas.height = 512;
         var canvas_context = canvas.getContext('2d')
         canvas_context.drawImage(
            image,
            this.state.zoomCropInfo['x'],
            this.state.zoomCropInfo['y'],
            this.state.zoomCropInfo['width'],
            this.state.zoomCropInfo['height'],
            0,
            0,
            canvas.width,
            canvas.height,
         )
         this.setState({
            imageBase64: canvas.toDataURL('image/jpeg'),
            zoomCropIconImage: false
         })
      } catch (err) {
         // console.log(err)
      }
   }

   changeIconImageFilePreview(event) {
      if (event.target.files && event.target.files[0]) {
         this.setState({ imageFile: event.target.files[0] })
      }
   }


   create_image_edit = create_image_edit

   render() {
      if (this.props.open_icon_image_edit === true) {
         this.setState({
            editIconImageOn: true,
            zoomCropIconImage: false,
         })
         this.props.setState({
            open_icon_image_edit: false,
         })
      }
      if (this.props.revertImage === true) {
         this.getFileFromUrl(`${paths.BACKEND_URL}api/user/icon`);
         this.imageToBase64(this.state.imageFile);
         this.props.setRevertImageFalse();
      }
      let social_media_divs = (<div></div>);
      let main_editor = (<div></div>);
      if (this.state.editIconImageOn) {

         let icon_image_invalid_file_type_div = "";
         if (this.state.invalidIconFile) {
            icon_image_invalid_file_type_div = (
               <div className="settings_upload_icon_image_invalid_file_text">
                  Upload failed due to invalid file type
               </div>
            )
         }
         if (this.state.zoomCropIconImage) {
            main_editor = (
               <Modal
                  open={this.state.zoomCropIconImage}
                  aria-labelledby="modal-modal-title"
                  aria-describedby="modal-modal-description"
                  sx={{ overflow: 'auto', paddingBottom: '40px', margin: 'auto', display: 'flex', zIndex: 99999 }}
                  className='crop-modal-dashbaord'
               >
                  <Fade
                     style={{
                        borderRadius: '0px',
                        border: 'none',
                        boxShadow: 'none',
                        outline: 'none',
                     }}
                     in={this.state.zoomCropIconImage}
                  >
                     <Grid
                        xs={12}
                        container
                        item
                        justifyContent="center"
                        height={'100%'}
                     >
                        <Grid
                           container
                           lg={6}
                           md={8}
                           sm={10}
                           xs={12}
                           style={{
                              padding: this.state.bottomMobilePadding,
                              backgroundColor: 'var(--rebranding-content-background-color)',
                              borderRadius: '10px',

                              margin: 'auto 20px',
                              position: 'relative',
                           }}
                           justifyContent="center"
                        >

                           <div style={{ position: 'absolute', top: '10px', zIndex: '9999', right: '10px', '&:hover': { cursor: 'pointer' } }}>
                              <a onClick={() => { { this.setState({ zoomCropIconImage: false }) } }}>
                                 <IoClose className={'modal-close-icon'} />
                              </a>
                           </div>

                           <Grid
                              container
                              xs={12}
                              style={{
                                 padding: '0px',
                                 height: '60px',
                                 paddingTop: '0px',
                                 borderRadius: '0px',
                                 position: 'relative',
                                 borderTopLeftRadius: '5px',
                                 borderTopRightRadius: '5px',
                              }}
                           >
                              <Grid
                                 item
                                 xs={10}
                                 style={{
                                    height: '40px',
                                    width: '40px',
                                    paddingLeft: '10%',
                                 }}
                              >

                                 <Typography
                                    style={{
                                       color: 'var(--light-theme-text-color)',
                                       fontSize: '26px',

                                       fontWeight: '600',
                                       paddingTop: '5px', position: window.innerWidth > 420 ? 'absolute' : 'relative',
                                       textAlign: 'center',
                                       left: window.innerWidth > 420 ? '50%' : 'unset',
                                       right: window.innerWidth > 420 ? '50%' : 'unset',
                                       width: '100%',
                                       transform: window.innerWidth > 420 ? 'translateX(-50%)' : 'translateX(0)'
                                    }}
                                 >
                                    Crop Profile Image
                                 </Typography>
                              </Grid>
                           </Grid>

                           <Grid
                              item
                              container
                              justifyContent="center"
                              xs={12}
                              marginTop='20px'
                           >
                              <Grid
                                 item
                                 container
                                 justifyContent="center"
                                 alignItems="center"
                                 display="flex"
                                 xs={12}
                                 sx={{}}
                              >
                                 <Cropper
                                    image={this.state.imageBase64}
                                    crop={this.state.crop}
                                    zoom={this.state.zoom}
                                    aspect={1}
                                    onCropChange={(crop) => this.setState({ crop: crop })}
                                    onCropComplete={(croppedArea, croppedAreaPixels) => {
                                       this.setState({ zoomCropInfo: croppedAreaPixels })
                                    }}
                                    cropShape={'round'}
                                    showGrid={false}
                                    objectFit="vertical-cover"
                                    style={{
                                       containerStyle: {
                                          height: 'calc(100vh - 330px)',
                                          position: 'relative',
                                          width: '90%',
                                          maxHeight: this.state.cropperHeight
                                       },
                                    }}
                                 />
                              </Grid>
                              <Grid
                                 item
                                 container
                                 justifyContent="center"
                                 alignItems="center"
                                 display="flex"
                                 xs={12}
                              >
                                 <CustomSlider
                                    style={{
                                       width: '300px',
                                       marginLeft: 'auto',
                                       marginRight: 'auto',
                                       marginTop: '20px',
                                    }}
                                    value={this.state.zoom}
                                    min={1}
                                    max={3}
                                    step={0.1}
                                    aria-labelledby="Zoom"
                                    onChange={(e, zoom) => this.setState({ zoom: zoom })}
                                    classes={{ container: 'zoom_slider' }}
                                 />
                              </Grid>
                           </Grid>
                           <Button
                              fullWidth
                              variant="contained"
                              sx={{
                                 backgroundColor: 'var(--brand-color)', fontSize: '14px',
                                 textTransform: 'none', width: '80%', borderRadius: '6px',
                                 boxShadow: 'none', marginBottom: '35px', fontWeight: '600',
                                 marginTop: '30px',
                                 ':hover': {
                                    bgcolor: 'var(--brand-color-hover)',
                                    color: 'white',
                                    boxShadow: 'none',
                                 },
                              }}
                              className="image_update_button"
                              type="submit" value="submit"
                              // Update Password Function
                              onClick={(e) => this.EditCropZoomIconImageOff(e)}
                           >Confirm Profile Image</Button>
                        </Grid>
                     </Grid>
                  </Fade>
               </Modal>
            )
         } else {
            let shortenedPath = ''
            if (this.state.imageFile && this.state.imageFile.name) {
               shortenedPath = /[^/]*$/.exec(this.state.imageFile.name)[0];
            } else {
               shortenedPath = ''
            }
            let same_image = ""
            main_editor = (
               <Modal
                  open={this.state.editIconImageOn}
                  aria-labelledby="modal-modal-title"
                  aria-describedby="modal-modal-description"
                  sx={{ overflow: 'auto', paddingBottom: '40px', margin: 'auto', display: 'flex', zIndex: 99999 }}
               >
                  <Fade
                     style={{
                        borderRadius: '0px',
                        border: 'none',
                        width: '100%',
                        boxShadow: 'none',
                        outline: 'none',
                     }}
                     in={this.state.editIconImageOn}
                  >
                     <Grid
                        xs={12}
                        container
                        item
                        justifyContent="center"
                        sx={{ position: 'relative', width: '100vw' }}
                        height={'100%'}
                     >




                        <Grid
                           container
                           lg={6}
                           md={8}
                           sm={10}
                           xs={12}
                           style={{
                              padding: this.state.bottomMobilePadding,
                              backgroundColor: 'var(--rebranding-content-background-color)',
                              borderRadius: '10px',
                              maxWidth: '500px',
                              margin: 'auto',
                              position: 'relative'
                           }}
                           justifyContent="center"
                        >

                           <div style={{ position: 'absolute', top: '10px', right: '10px', zIndex: '9999', '&:hover': { cursor: 'pointer' } }}>
                              <a onClick={() => {
                                 {
                                    this.setState({ imageFile: '', imageBase64: '', });
                                    this.getFileFromUrl(`${paths.BACKEND_URL}api/user/icon`);
                                    this.props.revertUserIcon();
                                    this.resetToOriginal();
                                    this.props.setRevertImageFalse();
                                    this.setState({ editIconImageOn: false })
                                 }
                              }}>
                                 <IoClose className={'modal-close-icon'} />
                              </a>
                           </div>

                           <Grid
                              container
                              xs={12}
                              style={{
                                 padding: '0px',
                                 height: '60px',
                                 paddingTop: '0px',
                                 borderRadius: '0px',
                                 position: 'relative',
                                 // backgroundColor: 'var(--rebranding-content-background-color)',
                                 borderTopLeftRadius: '5px',
                                 borderTopRightRadius: '5px',

                              }}
                           >
                              <Grid
                                 item
                                 xs={10}
                                 style={{
                                    height: '40px',
                                    width: '40px',
                                    paddingLeft: '10%',
                                 }}
                              >

                                 <h3
                                    style={{
                                       color: 'var(--light-theme-text-color)',
                                       fontSize: '20px',
                                       fontFamily: 'var(--main-font-family)',
                                       fontWeight: '600',
                                       paddingTop: '5px', position: window.innerWidth > 420 ? 'absolute' : 'relative',
                                       textAlign: 'center',
                                       left: window.innerWidth > 420 ? '50%' : 'unset',
                                       right: window.innerWidth > 420 ? '50%' : 'unset',
                                       width: '100%',
                                       transform: window.innerWidth > 420 ? 'translateX(-50%)' : 'translateX(0)'
                                    }}
                                 >
                                    Update Profile Image
                                 </h3>
                              </Grid>

                           </Grid>

                           <Grid
                              item
                              container
                              justifyContent="center"
                              xs={12}
                              marginTop='20px'
                           >
                              <Badge
                                 overlap="circular"
                                 anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                              >
                                 <Badge
                                    overlap="circular"
                                    anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                                 >
                                    <Avatar
                                       alt="icon mage"
                                       style={{
                                          width: '150px',
                                          height: '150px',
                                          objectFit: 'cover',
                                          border: this.props.creatorProfile === true ? 'solid 5px #fff' : 'solid 1px #C6D1DE',
                                          borderRadius: '1000px'
                                       }}
                                       src={this.props.influencerIconUpdated && !shortenedPath ? this.props.influencerIconUpdated : (this.state.imageBase64)}
                                    />
                                 </Badge>
                              </Badge>
                           </Grid>

                           <form
                              className="upload_user_icon_form"
                           >
                              <input
                                 type="file"
                                 accept="image/*"
                                 id="upload_icon_image_filepath"
                                 className="upload_icon_image_filepath"
                                 onChange={e => this.changeIconImageFilePreview(e)}
                              />
                           </form>
                           <Typography
                              style={{
                                 width: '80%',
                                 color: '#000',
                                 fontSize: '16px',
                                 fontWeight: '600',
                                 paddingTop: '20px',
                                 textAlign: 'center',
                                 paddingBottom: '10px',
                              }}
                           >
                              {shortenedPath}
                           </Typography>

                           <Grid container columns={40} sx={{ margin: 'auto', width: '80%', justifyContent: 'space-between' }}>
                              <Grid xs={40} md={19}>
                                 <Button
                                    fullWidth
                                    variant="contained"
                                    sx={{
                                       backgroundColor: 'var(--brand-color)', fontSize: '14px',
                                       textTransform: 'none', width: '100%', borderRadius: '6px',
                                       boxShadow: 'none', fontWeight: '600', marginTop: '10px',
                                       ':hover': {
                                          bgcolor: 'var(--brand-color-hover)',
                                          color: 'white',
                                          boxShadow: 'none',
                                       },
                                    }}
                                    className="image_update_button"
                                    type="submit" value="submit"
                                    // Update Password Function
                                    onClick={
                                       (event) => {
                                          event.preventDefault();
                                          document.getElementById('upload_icon_image_filepath').click()
                                       }
                                    }
                                 >
                                    <FaFileImage style={{
                                       paddingRight: '5px',
                                       fontSize: '16px',
                                       margin: '0px',
                                    }} />
                                    New
                                 </Button>
                              </Grid>

                              <Grid xs={40} md={19}>
                                 <Button
                                    fullWidth
                                    variant="contained"
                                    sx={{
                                       backgroundColor: 'var(--brand-color)', fontSize: '14px',
                                       textTransform: 'none', width: '100%', borderRadius: '6px',
                                       boxShadow: 'none', fontWeight: '600', marginTop: '10px',
                                       ':hover': {
                                          bgcolor: 'var(--brand-color-hover)',
                                          color: 'white',
                                          boxShadow: 'none',
                                       },
                                    }}
                                    className="image_update_button"
                                    type="submit" value="submit"

                                    onClick={(e) => this.EditCropZoomIconImageOn(e)}
                                 >
                                    <MdOutlineCrop style={{
                                       paddingRight: '5px',
                                       fontSize: '16px',
                                       margin: '0px',
                                    }} />Crop</Button>
                              </Grid>

                           </Grid>

                           <Typography
                              style={{
                                 width: '80%',
                                 color: 'var(--light-theme-text-color)',
                                 fontSize: '14px',
                                 fontWeight: '400',
                                 paddingTop: '20px',
                                 textAlign: 'center',
                              }}
                           >
                              By submitting your files to WithMe, you acknowledge that you agree to
                              WithMe's <a style={{ color: 'var(--brand-color)' }} href='/terms_and_conditions'>Terms
                                 & Conditions</a>
                           </Typography>
                           <Typography
                              style={{
                                 width: '80%',
                                 color: 'var(--light-theme-text-color)',
                                 fontSize: '14px',
                                 fontWeight: '400',
                                 paddingTop: '20px',
                                 textAlign: 'center',
                              }}
                           >
                              Please make sure that you do not violate others' copyright or privacy
                              rights.

                           </Typography>
                           <Button
                              fullWidth
                              variant="contained"
                              sx={{
                                 backgroundColor: 'var(--brand-color)', fontSize: '14px',
                                 textTransform: 'none', width: '80%', borderRadius: '6px',
                                 boxShadow: 'none', marginBottom: '35px', fontWeight: '600',
                                 marginTop: '30px',
                                 ':hover': {
                                    bgcolor: 'var(--brand-color-hover)',
                                    color: 'white',
                                    boxShadow: 'none',
                                 },
                              }}
                              className="image_update_button"
                              type="submit" value="submit"
                              // Update Password Function
                              onClick={(e) => {

                                 this.setState({ editIconImageOn: false });
                                 this.props.UpdateIconImagePush(e, this.state.imageBase64);
                                 // this.setState({imageFile: this.props.influencerIconUpdated});
                              }}
                           >Update Profile Image</Button>
                        </Grid>
                     </Grid>
                  </Fade>
               </Modal>
            )
         }
      } else {
         const pageName = this.props.searchParams.get("page");
         
         main_editor = pageName === 'home' ? null : (

            <div>

               <Avatar
                  sx={{
                     width: { xs: '100px', lg: '100px' },
                     height: { xs: '100px', lg: '100px' },
                     padding: '0px',
                     margin: 'auto',
                     boxSizing: 'border-box',
                     border: this.props.creatorProfile === true ? 'solid 5px #fff' : 'solid 1px #C6D1DE',
                     // opacity: avatarHovered ? '0.6' : '1',
                     transition: '0.3s'
                  }}
                  alt={this.state.imageBase64}

                  src={this.props.influencerIconUpdated ? this.props.influencerIconUpdated : this.state.imageBase64}
               />

               {/* {console.log('influencerIcon: ', this.props.influencerIconUpdated)}
                  {console.log('imageBase64: ', this.props.imageBase64)} */}
               {/* </Badge> */}

               {
                  window.innerWidth > 600 && this.props.is_me ?

                     // <Fade opposite>
                     <LightTooltip title="300px by 300px recommended. Accepted formats: .jpg & .png. Max file size: 4MB" placement="top-start">
                        <div
                           onClick={(event) => {
                              this.EditIconImageOn(event);
                           }}
                           // onMouseEnter={this.props.handleAvatarHover}
                           // onMouseLeave={this.props.handleAvatarExit}
                           className="banner-icon"
                           style={{
                              position: 'absolute',
                              top: '0px', // Adjust this value as needed
                              right: '0',
                              backgroundColor: 'rgba(0, 0, 0, 0.6)',
                              backdropFilter: 'blur(6px)',
                              borderRadius: '40px',
                              height: '35px',
                              width: '35px',
                              maxHeight: '35px',
                              maxWidth: '35px',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)',
                              zIndex: '1',
                              border: 'solid 1px rgba(255, 255, 255, 0.65)',
                           }}
                        >
                           <span style={{ color: '#fff', fontWeight: '500', width: '100%', height: '100%', display: 'flex' }}>
                              <FaImage style={{ margin: 'auto' }} />
                           </span>
                        </div>
                     </LightTooltip>
                     // </Fade>
                     :

                     <>

                        {/* {
                           this.props.customiseMode ? */}

                        {/* <Fade opposite> */}
                        <div
                           onClick={(event) => {
                              this.EditIconImageOn(event);
                           }}
                           // onMouseEnter={this.props.handleAvatarHover}
                           // onMouseLeave={this.props.handleAvatarExit}
                           className="banner-icon"
                           style={{
                              position: 'absolute',
                              top: '0px', // Adjust this value as needed
                              right: '0',
                              backgroundColor: 'rgba(0, 0, 0, 0.6)',
                              backdropFilter: 'blur(6px)',
                              borderRadius: '40px',
                              height: '35px',
                              width: '35px',
                              maxHeight: '35px',
                              maxWidth: '35px',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)',
                              border: 'solid rgb(255, 255, 255, 0.65) 1px',
                              zIndex: '1',
                           }}
                        >
                           <span style={{ color: '#fff', fontWeight: '500', width: '100%', height: '100%', display: 'flex' }}>
                              <FaImage style={{ margin: 'auto' }} />
                           </span>
                        </div>
                        {/* </Fade> */}
                        {/* :
                              null

                        } */}


                     </>





               }


            </div>


         )
      }
      return (
         <div>
            {main_editor}
         </div>
      )
   }
}

export default withRouter(AvatarEditorCreatorView);
